import { TwContainer } from '~/lib/TwContainer';
import img1 from '/images/sales.svg';
import img2 from '/images/sales (1).svg';
import img3 from '/images/brain.svg';
import img4 from '/images/project.svg';
import img5 from '/images/test.svg';

export const SectionTwo = () => {
	return (
		<section className="bg-white">
			<TwContainer className="py-20 px-8 grid gap-12">
				<div className={'col-span-full flex flex-col mx-auto  text-center gap-2'}>
					<h1 className="font-semibold text-primary text-5xl max-w-3xl font-saira">A Team for your next solution</h1>
					<div className="max-w-2xl text-gray-700 font-inter">
						Our team will Build a A-Z solution for your business. You just need to provide your requirements. Everything else will be handled by our
						world class design and development team.
					</div>
				</div>
				<div className={'flex flex-row flex-wrap justify-center gap-12'}>
					<div className="flex flex-col gap-4 md:basis-2/5">
						<img
							className={'mx-auto'}
							src={img4}
							width="80"
							alt=""
						/>
						<div className={'text-center'}>
							<h2 className="font-medium text-base text-primary font-saira">Like an in-house team</h2>
							<div className="text-gray-600 font-inter">
								We work as an extension of your team, not as a vendor. We help you to participate in a deeply collaborative process to develop the
								desired product. We will be in constant communication with your team every step of the way.
							</div>
						</div>
					</div>
					<div className="flex flex-col gap-4 md:basis-2/5">
						<img
							className={'mx-auto'}
							src={img1}
							width="80"
							alt=""
						/>
						<div className={'text-center'}>
							<h2 className="font-medium text-base text-primary font-saira">General analysis and requirements gathering</h2>
							<div className="text-gray-600 font-inter">
								Effective communication, collaboration, and documentation are essential for successful software general analysis and requirements
								gathering to ensure that the software product meets the needs of its users and stakeholders.
							</div>
						</div>
					</div>
					<div className="flex flex-col gap-4 md:basis-2/5">
						<img
							className={'mx-auto'}
							src={img2}
							width="80"
							alt=""
						/>
						<div className={'text-center'}>
							<h2 className="font-medium text-base text-primary font-saira">Product design and development</h2>
							<div className="text-gray-600 font-inter">
								Effective product design and coding require a deep understanding of the software requirements, user needs, and industry best practices
								to deliver a quality software product that meets the desired objectives.
							</div>
						</div>
					</div>
					<div className="flex flex-col gap-4 md:basis-2/5">
						<img
							className={'mx-auto'}
							src={img5}
							width="80"
							alt=""
						/>
						<div className={'text-center'}>
							<h2 className="font-medium text-base text-primary font-saira">Quality Assurance & Testing</h2>
							<div className="text-gray-600 font-inter">
								At Champtek, we prioritize quality assurance and testing to ensure that our software products meet the highest standards of quality,
								reliability, and performance.
							</div>
						</div>
					</div>
					<div className="flex flex-col gap-4 md:basis-2/5">
						<img
							className={'mx-auto'}
							src={img3}
							width="80"
							alt=""
						/>
						<div className={'text-center'}>
							<h2 className="font-medium text-base text-primary font-saira">Learn, Rinse, Repeat</h2>
							<div className="text-gray-600 font-inter">
								We emphasizes the importance of reflecting on past experiences, analyzing what went well and what didn't, and applying those insights
								to improve the future outcome.
							</div>
						</div>
					</div>
				</div>
			</TwContainer>
		</section>
	);
};
